import React from 'react';
import {Navbar} from 'react-bootstrap';
import LinksSecondary from './LinksSecondary';
import { useTranslation } from 'react-i18next';
import LogoInnoCAPE from './LogoInnoCAPE';

const NavigationSecondary = (props) => {
    const { t } = useTranslation();

    return (<>
        <Navbar
            style={
                {
                    display: 'flex',
                    position: 'relative',
                    background: 'white',
                    borderTop: '3px solid #ececec',
                    marginTop: 'auto',
                    padding: '0 1rem',
                    flexShrink: 0,
                    boxShadow: '0rem 0rem 2rem rgba(0,0,0,0.075)',
                    zIndex: 1
                }
            }
        >
            <div
                style={
                    {
                        display: 'flex',
                        flexWrap: 'wrap',
                        flexGrow: 1,
                        flexShrink: 0,
                        minHeight: '8rem',
                        width: '100%',
                        padding: '0.25rem 0'
                    }
                }
            >
                <style>
                    {
                        `
                            .NavigationSecondary__innocape-url {
                                opacity: 0.75;
                            }

                            .NavigationSecondary__innocape-url:hover {
                                opacity: 1;
                            }
                        `
                    }
                </style>
                <div
                    style={
                        {
                            display: 'inline-flex',
                            flexGrow: 1,
                            flexShrink: 1,
                            maxHeight: '10em',
                            padding: '1.5rem',
                            paddingRight: 'calc(1rem + 2vw)',
                            paddingLeft: 'calc(1rem + 2vw)',
                            marginRight: 'auto'
                        }
                    }
                    className="NavigationSecondary__innocape-url"
                >
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://innocape.eu/"
                        title={t('NavigationSecondary.tooltip-innocape-site-link')}
                        style={
                            {
                                display: 'flex',
                                maxWidth: '20em',
                                flexGrow: 1,
                                flexShrink: 1,
                                alignContent: 'flex-start'
                            }
                        }
                    >
                        <LogoInnoCAPE />
                    </a>
                </div>
                <div
                    style={
                        {
                            display: 'flex',
                            flexBasis: 'max-content',
                            padding: '1rem',
                            alignItems: 'center',
                            justifyContent: 'flex-end',
                            paddingRight: 'calc(1rem + 2vw)',
                            paddingLeft: 'calc(1rem + 2vw)',
                            fontFamily: 'Ubuntu, sans-serif',
                            fontSize: '1.1rem'
                        }
                    }
                >
                    <LinksSecondary />
                </div>
            </div>
        </Navbar>
    </>)
}

export default NavigationSecondary;
